import classNames from "classnames";

export const PURPOSES = [
  { text: "Commercial\nB2B items", value: "SOLD" },
  { text: "Gift", value: "GIFT" },
  { text: "Samples\nfor a prospect", value: "SAMPLE" },
  { text: "Defective items\nfor repair & return", value: "REPAIR_AND_RETURN" },
  { text: "New goods\nfor individual's use", value: "NOT_SOLD" },
  { text: "Used Belongings", value: "PERSONAL_EFFECTS" },
];

const parseNewLine = (str) => {
  const returnStr = [];
  for (const string of str.split("\n")) {
    returnStr.push(
      <p key={string} className="">
        {string}
      </p>
    );
  }
  return returnStr;
};

export default function ShippingPurposeSelector({
  selectedPurpose,
  onPurposeChange,
  isValid,
  containerClassName = "mt-6 bg-white flex flex-col text-center w-full md:rounded-xl shadow",
  disabled,
}) {
  return (
    <div className={containerClassName}>
      <div className="flex flex-col md:rounded-xl py-6">
        <p className="text-dark-purple font-semibold text-xl spacing-xs">
          What&apos;s your purpose
          <br className="md:hidden" /> of shipping?
        </p>
        <p className="text-error-red mt-2 mb-4 h-4">
          {!isValid ? "Please pick a purpose" : ""}
        </p>
        <div className="w-[86%] md:w-full md:px-8 mx-auto">
          <div className="grid md:grid-cols-3 md:grid-rows-2 gap-4 lg:gap-x-6 place-items-center">
            {PURPOSES.map(({ text, value }) => (
              <button
                type="button"
                key={value}
                id={value}
                className={classNames(
                  "form-input w-full h-[60px]",
                  selectedPurpose === value
                    ? "bg-light-purple text-white border-transparent"
                    : "bg-white hover:bg-light-purple/10 group hover:border hover:border-light-purple"
                )}
                onClick={() => {
                  onPurposeChange(value);
                }}
                disabled={disabled}
              >
                {parseNewLine(text)}
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
